(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * @see resources/js/app/campaigns/_campaignactioncenter.js
 * @type {{$hiddeninputs: Array, fieldOptions: {}}}
 */
var CampaignActionCenter = {
    $hiddeninputs: [],
    fieldOptions: {}
};

CampaignActionCenter.init = function () {
    CampaignActionCenter.fieldOptions = dbFieldOptions || {};
};

/**
 * Function handles the display of the form fields/input on the acquisition campaign
 */
CampaignActionCenter.displayFormFields = function () {

    var displayOptions = {};

    $('#action-form :input, #action-form :checkbox, #action-form :radio').each(function () {
        var $me = $(this);

        //Don't remove the buttons, or touch specific elements
        if ($me.prop('tagName') == 'BUTTON' || $me.parent().hasClass('email-message')) {
            return true;
        }

        displayOptions = CampaignActionCenter.getDisplayOptions($me);

        CampaignActionCenter.handleRequiredDisplay($me, displayOptions.isFieldRequired);

        // always show Custom fields
        if (CampaignActionCenter.isCustomField($me)) {
            $me.show();
            $me.parent().show();
            $('#customfieldscontainer .form-group').show();
            return true;
        }

        CampaignActionCenter.handleShowField($me, displayOptions.showField);
    });
    // Show the acquisition campaign form
    $("#action-form").show();
};

/**
 * Handle showing/hiding the given field
 * @param fieldElt
 * @param showField
 * @returns {boolean}
 */
CampaignActionCenter.handleShowField = function (fieldElt) {
    var showField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    // short-circuit if we are not working with an object for the field element
    if ((typeof fieldElt === 'undefined' ? 'undefined' : _typeof(fieldElt)) != 'object') {
        return false;
    }

    var fieldName = CampaignActionCenter.interpretFieldName(fieldElt);

    if (showField === true) {
        fieldElt.parent().parent().show();

        if (fieldName == 'phone') {
            $('.phone-info-icon').show();
        }
        return true;
    } else {
        if (fieldName == 'name' || fieldName == 'prefix') {
            fieldElt.parent().parent().hide();
        } else {
            // If hiding prefix, make name field full width
            if (fieldName == 'title') {
                fieldElt.parent().hide(null, function () {
                    $("#fullname").parent().attr({
                        class: 'col-md-12',
                        style: ''
                    });
                });
            } else {
                fieldElt.parent().hide();
            }
        }
        if (fieldName == 'phone') {
            $('.phone-info-icon').hide();
        }
    }
};

/**
 * Get options for displaying a given field
 * @param $fieldElt
 * @returns {{ showField: boolean, isFieldRequired: boolean}}
 */
CampaignActionCenter.getDisplayOptions = function ($fieldElt) {
    // Get the default display options object
    var displayOptions = { showField: true, isFieldRequired: false },
        fieldName = "",
        fieldOption = null,
        fieldNameDB = null;

    // short-circuit if we are not working with an object for the field element
    if ((typeof $fieldElt === 'undefined' ? 'undefined' : _typeof($fieldElt)) != 'object') {
        return displayOptions;
    }

    fieldName = CampaignActionCenter.interpretFieldName($fieldElt);
    if (fieldName == 'fullname') {
        fieldName = 'name';
    }
    if (fieldName) {
        fieldNameDB = CampaignActionCenter.calculateFieldNameDB(fieldName);
    }

    if (fieldNameDB) {
        fieldOption = CampaignActionCenter.fieldOptions.standard['fields' + fieldNameDB];
        if (fieldOption === 1 || fieldOption === 2) {
            displayOptions.showField = true;
            if (fieldOption === 1) {
                displayOptions.isFieldRequired = true;
            } else {
                displayOptions.isFieldRequired = false;
            }
        } else {
            displayOptions.showField = false;
            displayOptions.isFieldRequired = false;
        }
    }
    return displayOptions;
};

/**
 * Determine if a field is required to add needed html markup for the field.
 * @param fieldElt
 * @param isFieldRequired
 * @returns {boolean}
 */
CampaignActionCenter.handleRequiredDisplay = function (fieldElt) {
    var isFieldRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    // short-circuit if we are not working with an object for the field element
    if ((typeof fieldElt === 'undefined' ? 'undefined' : _typeof(fieldElt)) != 'object') {
        return false;
    }

    if (isFieldRequired === true) {
        CampaignActionCenter.addRequiredFieldMarkup(fieldElt);
    } else {
        fieldElt.prop('required', false);
        fieldElt.parent().find('.input-required-icon').remove();
    }
};

/**
 * Adds Html markup (mostly the * symbol) for the required field
 * @param fieldElt
 * @returns {boolean}
 */
CampaignActionCenter.addRequiredFieldMarkup = function (fieldElt) {
    // short-circuit if we are not working with an object for the field element
    // And the required field html iff we haven't already added it for the field
    if ((typeof fieldElt === 'undefined' ? 'undefined' : _typeof(fieldElt)) != 'object' || fieldElt.parent().find('.input-required-icon').length) {
        return false;
    }
    fieldElt.prop('required', true);
    var fieldName = CampaignActionCenter.interpretFieldName(fieldElt);
    if (fieldName == "phone") {
        var parentWidth = fieldElt.parent().parent().width();
        var left = parentWidth + fieldElt.width() + 20;
        $("<span class='input-required-icon' style='left:" + left + "px'><i class='fa fa-asterisk'></i></span>").insertAfter(fieldElt);
    } else if (fieldName == "zip5") {
        var parentWidth = fieldElt.parent().parent().width();
        var left = parentWidth + fieldElt.width() + 20;
        $("<span class='input-required-icon input-required-icon-zip' style='left:" + left + "px'><i class='fa fa-asterisk'></i></span>").insertAfter(fieldElt);
    } else {
        $("<span class='input-required-icon'><i class='fa fa-asterisk'></i></span>").insertAfter(fieldElt);
    }
};

/**
 * Determine the field name from given field object
 * @param fieldElt
 */
CampaignActionCenter.interpretFieldName = function (fieldElt) {
    return fieldElt.attr('data-fieldname') || fieldElt.attr('name');
};

/**
 * Determines if the given element is a custom field
 * @param fieldElt
 * @returns {boolean}
 */
CampaignActionCenter.isCustomField = function (fieldElt) {
    return fieldElt.attr('name').indexOf('fields[') != -1;
};

/**
 * Compute the name we have in the database from the given field's name
 * @param fieldName
 * @returns {string}
 */
CampaignActionCenter.calculateFieldNameDB = function (fieldName) {
    if (!fieldName) {
        return "";
    }
    return fieldName.substr(0, 1).toUpperCase() + fieldName.substr(1);
};

$(document).ready(function () {
    window.CampaignActionCenter = CampaignActionCenter;
    CampaignActionCenter.init();
    CampaignActionCenter.displayFormFields();
});

},{}]},{},[1]);
